import { useEffect, useState } from "react";
import PageHero from "../../components/PageHero.jsx";
import { fetchLatestOfftrackRelease } from "../../lib/offtrackApi.js";

function formatDate(value) {
    if (!value) return "–";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "–";

    return new Intl.DateTimeFormat("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }).format(date);
}

export default function Overlay() {
    const [release, setRelease] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let active = true;

        (async () => {
            try {
                setLoading(true);
                setError("");
                const data = await fetchLatestOfftrackRelease();
                if (!active) return;
                setRelease(data || null);
            } catch (err) {
                if (!active) return;
                setError(err?.message || "Die aktuelle Version konnte nicht geladen werden.");
            } finally {
                if (active) setLoading(false);
            }
        })();

        return () => {
            active = false;
        };
    }, []);

    const version = release?.latest_version || null;
    const downloadUrl = release?.download_url || null;
    const releaseNotes = release?.release_notes || "";

    return (
        <div className="rv-page">
            <PageHero kicker="RaceVision-Tool" title="Overlay">
                Das RaceVision-Tool verbindet sich direkt mit iRacing und stellt das RaceVision Overlay bereit.
                Hier findest du immer die aktuell veröffentlichte Windows-Version. Infos zur Datenverarbeitung findest du in unserer <a href="/datenschutz">Datenschutzerklärung</a>.
            </PageHero>

            <section className="rv-modern-card rv-modern-card--accent">
                <div className="rv-section-head">
                    <div>
                        <div className="rv-section-kicker">Download</div>
                        <h2 style={{ margin: 0 }}>RaceVision-Tool</h2>
                    </div>

                    {version && (
                        <span className="rv-status-pill rv-status-pill--ok">
                            Version {version}
                        </span>
                    )}
                </div>

                <p className="rv-modern-muted" style={{ marginTop: 0 }}>
                    Die Anwendung wird als einzelne Windows-EXE bereitgestellt. Eine separate Python-Installation ist nicht erforderlich.
                </p>

                {loading && (
                    <div className="rv-message">
                        Aktuelle Version wird geladen …
                    </div>
                )}

                {!loading && error && (
                    <div className="rv-message" style={{ color: "var(--warn)" }}>
                        {error}
                    </div>
                )}

                {!loading && !error && release && (
                    <>
                        <div className="rv-info-grid" style={{ marginTop: 16 }}>
                            <div className="rv-info-tile">
                                <div className="rv-info-tile__label">Aktuelle Version</div>
                                <div className="rv-info-tile__value">{version || "–"}</div>
                            </div>

                            <div className="rv-info-tile">
                                <div className="rv-info-tile__label">Veröffentlicht</div>
                                <div className="rv-info-tile__value">{formatDate(release?.published_at)}</div>
                            </div>

                            <div className="rv-info-tile">
                                <div className="rv-info-tile__label">Plattform</div>
                                <div className="rv-info-tile__value">Windows</div>
                            </div>
                        </div>

                        {releaseNotes && (
                            <div style={{ marginTop: 18 }}>
                                <div className="rv-section-kicker">Release Notes</div>
                                <div className="rv-modern-muted" style={{ whiteSpace: "pre-line" }}>
                                    {releaseNotes}
                                </div>
                            </div>
                        )}

                        <div style={{ marginTop: 22 }}>
                            {downloadUrl ? (
                                <a
                                    className="btn btn--accent"
                                    href={downloadUrl}
                                    style={{ textDecoration: "none" }}
                                >
                                    RaceVision-Tool herunterladen
                                </a>
                            ) : (
                                <div className="rv-message">
                                    Für diese Version ist noch kein Download hinterlegt.
                                </div>
                            )}
                        </div>
                    </>
                )}
            </section>
        </div>
    );
}
